import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import CasteForm from '../components/forms/CasteForm';
import '../styles/EmployeeMaster.css';
import CasteTable from '../components/CasteTable';

const CasteEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams(); // ✅ Get ID from route

     const [casteData, setCasteData] = useState(null);
     const [loading, setLoading] = useState(false);

     // ✅ Show modal only if URL starts with /sbu/edit
     const showModal = location.pathname.startsWith('/caste/edit');

     const handleCloseModal = () => {
          navigate('/caste'); // Go back to list
     };

     // ✅ Fetch SBU details by ID
     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               fetch(`${baseUrl}/getCasteById/${id}`)
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) {
                              setCasteData(data.data);
                         } else {
                              setCasteData(null);
                         }
                         setLoading(false);
                    })
                    .catch(err => {
                         console.error('Error fetching SBU by ID:', err);
                         setLoading(false);
                    });
          }
     }, [id, showModal, baseUrl]);

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Caste Master</h2>
               </div>

               {/* Table of SBUs */}
               <CasteTable />

               {/* Edit Modal */}
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Edit Caste</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         {loading ? (
                              <div className="text-center">
                                   <Spinner animation="border" /> Loading...
                              </div>
                         ) : casteData ? (
                              <CasteForm casteId={id} initialData={casteData} /> // ✅ Pass data to form
                         ) : (
                              <p className="text-center">No data found for this SBU.</p>
                         )}
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default CasteEditModel;
